import { InputV1, styled, css, Flex, DrawerV2Props } from '@withjoy/joykit';

export const StyledSearchContainer = styled(Flex)<{ isMobile?: boolean }>`
  width: 100%
    ${props =>
      props.isMobile &&
      css`
        svg {
          width: 40px;
          height: 40px;
        }
      `};
  & > div,
  form {
    width: 100%;
  }
`;

export const StyledSearchInput = styled(InputV1)`
  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    display: none;
  }
  font-size: 24px;
  ::-webkit-input-placeholder {
    font-size: 24px;
  }
  line-height: 34px;
`;

export const StyledSearchButton = styled(Flex)<{ visible: boolean; isMobile?: boolean }>`
  display: ${props => (props.visible ? 'flex' : 'none')};
  justify-content: space-around;
  align-items: center;
  background-color: ${props => props.theme.colors.mono14};
  width: ${props => (props.isMobile ? '44px' : '114px')};
  border-radius: ${props => (props.isMobile ? '50%' : '20px')};
  color: ${props => props.theme.colors.white};
  padding: ${props => (props.isMobile ? '11.5px' : '8px 16px 8px 12px')};

  ${props =>
    !props.isMobile &&
    css`
      margin: 0 56px;
      svg {
        margin-right: 8px;
      }
    `}
`;

export const DRAWER_OVERRIDES: DrawerV2Props['overrides'] = {
  Content: {
    props: {
      boxShadow: '0px 7px 27px rgba(44, 41, 37, 0.06), 0px 4px 16px rgba(0, 0, 0, 0.07)',
      opacity: '1 !important',
      borderBottomLeftRadius: 3,
      borderBottomRightRadius: 3
    }
  }
};
